jQuery(document).ready(function($) {

  // Primary navigation sub menus
  $('.main-navigation .menu-item-has-children > a').on('touchend', function(event) {
    if (window.matchMedia("(min-width: 45em)").matches) {
      event.preventDefault();
      var $currentMenu = $(this).siblings('.sub-menu');
      if ( $currentMenu.hasClass('is-visible') ) {
        window.location.href = $(this).attr('href');
      }
      $('.sub-menu').not($currentMenu).removeClass('is-visible');
      $currentMenu.toggleClass('is-visible');
    }
  });

  // Close offscreen navigation on outside click
  $(document).on('click', function(event) {
    if ( $(event.target).closest('.page-overlay').length ) {
      $('body').removeClass('offscreen-nav-visible');
      $('.js-offscreen-navigation').removeClass('is-visible');
      $('.js-toggle-menu').removeClass('is-active');
    }
  });

  // Hide snabbfakta
  $('.js-casino-list').on('mouseenter', '.casino-list__col', function(event) {
    if ( ! $(this).hasClass('casino-list__col--toggle') ) {
      if (window.matchMedia("(min-width: 71.25em)").matches) {
        $(this).closest('.casino-list__item').children('.js-col-wrap').removeClass('is-visible');
      }
    }
  });

  $('.js-toggle-menu').on('click', function(event) {
    event.preventDefault();
    $(this).toggleClass('is-active');
    $('.js-offscreen-navigation').toggleClass('is-visible');
    $('body').toggleClass('offscreen-nav-visible');
  });
  $('.js-offscreen-navigation .menu-item-has-children').append('<span class="toggle-sub-menu"></span>');
  $('.js-offscreen-navigation').on('click', '.toggle-sub-menu', function(event) {
    event.preventDefault();
    $(this).toggleClass('is-active');
    $(this).siblings('.sub-menu').slideToggle(150);
  });

  /* ScrollTo init */
  scrollToElement('.js-scroll-to, .js-page-navigation a');

  function addScrollClass() {
    $('body').toggleClass('is-scrolled', $(document).scrollTop() > 480);
  }
  document.addEventListener('scroll', addScrollClass, { passive: true });
  document.addEventListener('touchmove', addScrollClass, { passive: true });

  if ( $('.casino-info').length > 0 ) {
    var inview = new Waypoint.Inview({
      element: $('.site-footer')[0],
      enter: function(direction) {
        $('.js-cta-mobile').toggleClass('is-hidden');
      },
      exited: function(direction) {
        $('.js-cta-mobile').toggleClass('is-hidden');
      }
    });
  }

  $('.js-toggle-section').on('click', function(event) {
    event.preventDefault();
    if (window.matchMedia("(min-width: 45em)").matches) {
      $(this).toggleClass('is-hidden').siblings('.js-toggle-section-content').toggleClass('is-hidden');
    } else {
      $(this).toggleClass('is-mobile-hidden').siblings('.js-toggle-section-content').toggleClass('is-mobile-hidden');
    }
  });

  // Slots search
  $('.js-search-cards').on('submit', function(event) {
    event.preventDefault();
  });
  $('.js-search-cards input').on('keyup', function(event) {
    $('.js-card').removeClass('flex').addClass('is-hidden');
    var current_term = $(this).val().toLowerCase();
    if ( current_term < 1 ) {
      $('.js-card').addClass('flex').removeClass('is-hidden');
      return;
    }
    $('.js-card[data-name*="' + current_term + '"]').addClass('flex').removeClass('is-hidden');
  });

  // Cookie agreement
  $('.js-close-cookie').on('click', function(event) {
    event.preventDefault();
    $('.js-cookie-agreement').removeClass('is-visible');
    var data = {
      'action': 'nv_cookie_agreement',
    };
    jQuery.post(wp_js_data_main.ajax_url, data, function(response) {});
  });
  if (document.cookie.split(';').filter(function(item) {
    return item.indexOf('nv_cookie_agreement=') >= 0;
  }).length == 0) {
    $('.js-cookie-agreement').addClass('is-visible');
  }

  $('.js-toggle-search').on('click', function(event) {
    event.preventDefault();
    $('.js-toggle-menu').removeClass('active');
    $('.js-main-navigation').removeClass('is-visible');
    $('body').removeClass('mobile-nav-visible');
    $('.js-toggle-search, .js-search').toggleClass('is-open');
    if ( $(this).hasClass('is-open') ) {
      $('.js-search-field').focus().select();
    }
  });
  // Close dropdowns on outside click
  $(document).on('click touchend', function(event) {
    if ( ! $(event.target).closest('.js-toggle-search').length && ! $(event.target).closest('.js-search').length ) {
      $('.js-toggle-search, .js-search').removeClass('is-open');
    }
  });

  var ac_input = $('.js-casino-search-autocomplete');
  var list = wp_js_data_main.autocomplete.results;
  new Awesomplete( ac_input[0], {
    list: list,
    replace: function(text) {
      this.input.value = text;
    },
    // filter: Awesomplete.FILTER_STARTSWITH,
    sort: false,
    autoFirst: true,
  });
  ac_input[0].addEventListener("awesomplete-select", function(e){
    window.location.assign(e.text.value[1]);
  }, false);
  $('.js-header-search-form').on( 'submit', function(event) {
    event.preventDefault();
  });

  // Reading progress indicator
  if (window.matchMedia("(max-width: 44.9375em)").matches) {
    var getMax = function(){
      return $(document).height() - $(window).height();
    };
    var getValue = function(){
      return $(window).scrollTop();
    };

    // Browser supports progress element
    var progressBar = $('.read-indicator');

    // Set the Max attr for the first time
    progressBar.attr({ max: getMax() });

    document.addEventListener('scroll', function() {
      // On scroll only Value attr needs to be calculated
      progressBar.attr({ value: getValue() });
    }, { passive: true });

    $(window).on('resize', function(){
      // On resize, both Max/Value attr needs to be calculated
      progressBar.attr({ max: getMax(), value: getValue() });
    });
  }

  // Read more
  $('body').on('click', '.js-toggle-readmore', function(event) {
    event.preventDefault();
    if ( $(this).hasClass('is-collapsed') ) {
      $(this).removeClass('is-collapsed').html('Visa mindre &uarr;').siblings('.js-toggle-section-content').fadeIn(200);
    } else {
      $(this).addClass('is-collapsed').html('Läs mer &darr;').siblings('.js-toggle-section-content').fadeOut(200);
    }
  });

  // Page nav
  $('body').on('click', '.js-page-navigation-b__toggle', function(event) {
    event.preventDefault();
    if ( $(this).hasClass('is-collapsed') ) {
      $(this).removeClass('is-collapsed').siblings('.js-page-navigation-b__list').removeClass('is-collapsed');
    } else {
      $(this).addClass('is-collapsed').siblings('.js-page-navigation-b__list').addClass('is-collapsed');
    }
  });

  stickybits(document.getElementById('site-header'));
});

function scrollToElement(selector) {
  jQuery(selector).on('click', function(e) {
    var parser = document.createElement('a');
    parser.href = jQuery(this).attr('href');
    var target = jQuery(parser.hash);
    var offset = jQuery(this).data('offset');
    if ( 'undefined' === typeof(offset) && window.matchMedia("(min-width: 45em)").matches && window.matchMedia("(max-width: 63.9375em)").matches) {
      offset = 145;
    } else if ( 'undefined' === typeof(offset) && window.matchMedia("(min-width: 64em)").matches ) {
      offset = 100;
    } else if ( 'undefined' === typeof(offset) ) {
      offset = 120;
    }
    if (target) {
      e.preventDefault();
      var distance = jQuery(target).offset().top;
      var speed = 1750;
      if ( distance < 500 ) {
        speed = 750;
      } else if ( distance < 1500 ) {
        speed = 1250;
      }
      jQuery('html, body').animate({
        scrollTop: jQuery(target).offset().top - offset
      }, speed, 'easeOutQuart');
    }
  });
}
